import React from 'react'
import styles from './styles.module.scss'
import SvgCalendar from '@/src/assets/svgs/collection/calendar.svg'
import Merchant from '@/src/interfaces/merchant/merchant'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useTranslations } from 'next-intl'

interface Props {
    merchant: Merchant.Response
}

export default function BusinessHours({ merchant }: Props) {
    const { polling } = useMerchant()
    const t = useTranslations('profile')

    const isCurrentDayAndTimeValid = (startTime?: string, endTime?: string, dayOfWeek?: string): boolean => {
        const currentDate = new Date()

        const currentDay = currentDate.toLocaleDateString('en-US', { weekday: 'long' })

        if (dayOfWeek && currentDay !== dayOfWeek)
            return false

        if (!startTime || !endTime) return false

        const [startHour, startMinute] = startTime.split(':').map(Number)
        const [endHour, endMinute] = endTime.split(':').map(Number)

        const start = new Date()
        start.setHours(startHour, startMinute, 0)

        const end = new Date()
        end.setHours(endHour, endMinute, 0)

        return currentDate >= start && currentDate <= end
    }

    const groupDays = merchant.openingHours.reduce((acc, curr) => {
        const { dayOfWeek, startTime, endTime } = curr

        if (acc.has(dayOfWeek))
            acc.get(dayOfWeek)?.push({ startTime, endTime })
        else
            acc.set(dayOfWeek, [{ startTime, endTime }])

        return acc
    }, new Map<string, { startTime: string, endTime: string }[]>())

    const currentDay = new Date().toLocaleDateString('en-US', { weekday: 'long' })

    return (
        <div className={styles.container}>
            <h2 className={`${styles.title} font-lg`}>Horário de funcionamento</h2>
            <div className={styles.imageArea}>
                <span className={`${polling?.model?.isOpened ? styles.openedNowStatus : styles.closedNowStatus} font-sm`}>{polling?.model?.isOpened ? 'Aberto Agora' : 'Fechado'}</span>
            </div>
            <div className={styles.dateHourArea}>
                {
                    Array.from(groupDays.entries()).map(([dayOfWeek, hours], index) => (
                        <div className={styles.row} key={index}>
                            <span className={`${styles.dayOfWeek} ${currentDay === dayOfWeek && styles.week}`}>
                                {t(dayOfWeek.toLowerCase()).slice(0, 3).toUpperCase()}
                            </span>
                            <div className={styles.hours}>
                                {
                                    hours.map((hour, idx) => (
                                        <span key={idx} className={`${isCurrentDayAndTimeValid(hour.startTime, hour.endTime, dayOfWeek) && styles.time}`}>
                                            {`${hour.startTime.slice(0, 5)} às ${hour.endTime.slice(0, 5)}`}
                                        </span>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}